<template>
  <b-modal id="bv-modal-referels" hide-footer no-close-on-backdrop no-close-on-esc scrollable size="lg">
    <template #modal-header>
      <h4>{{ $t("my_referrals") }}</h4>
      <b-button
        size="sm"
        variant="outline-light"
        class="ml-auto"
        @click="$bvModal.hide('bv-modal-referels')"
      >
        <i class="fas fa-times"></i>
      </b-button>
    </template>
    <b-overlay :show="isLoading" class="rounded" variant="transparent">
      <template #overlay>
        <b-img
          width="100"
          :src="require('@/assets/img/brand/loader.gif')"
          alt=""
        />
      </template>
      <div class="mb-4">
        <label class="table-text">{{ $t("link-referrers") }}</label>
        <div class="input-group">
          <h5>
            <a
              :href="referrers ? referrers : '#'"
              target="_blank"
              rel="noopener"
            >
              {{ referrers ? referrers : "" }}
            </a>

            <i
              class="far fa-copy ml-2"
              style="cursor: pointer"
              v-clipboard:copy="referrers"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            ></i>
          </h5>
        </div>
      </div>
      <ReferralsTable />
    </b-overlay>
  </b-modal>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ReferralsTable from "./Referrals/ReferralsTable.vue";
export default {
  components: {
    ReferralsTable,
  },
  async mounted() {
    this.referrers = await this.referenLink(this.userData.id);
  },
  data() {
    return {
      referrers: "",
    };
  },
  methods: {
    ...mapActions({
      referenLink: "referenLink",
    }),
    show() {
      this.$bvModal.show("bv-modal-referels");
    },
    onCopy(err) {
      this.$toast.success(this.$t("message-copy-link-success"), {
        position: "top-right",
      });
    },
    onError(e) {
      this.$toast.error(this.$t("message-copy-link-fail"), {
        position: "top-right",
      });
      console.log(err);
    },
  },
  computed: {
    ...mapGetters({
      userData: "user",
      isLoading: "isLoading",
    }),
  },
};
</script>